import socketio from '@/common/utils/socketio.connection';
import AuthorizationError from '@/common/utils/errors/AuthorizationError';
import useAuthStore from '@/common/store/pinia/auth';
import useAppModeStore from '@/common/store/pinia/appMode';
import isSelfService from '@/common/utils/isSelfService';
import api from '@/common/utils/api';

let socketLoginTimeoutId = null;

const actions = {
  CONNECT() {
    const authStore = useAuthStore();
    const appModeStore = useAppModeStore();
    const scopedToken = authStore.getScopedToken;

    if (isSelfService() && !scopedToken) {
      throw new AuthorizationError();
    }

    socketio.io.opts.path = appModeStore.preset.websocket.wsUrl;
    socketio.io.opts.query = appModeStore.preset.websocket.queryParams;
    socketio.io.opts.transportOptions = {
      polling: {
        extraHeaders: {
          ...api.getAuthorizationHeaders({}),
          ...appModeStore.preset.websocket.headers
        }
      }
    };

    socketio.open();
  },
  DISCONNECT({ commit }) {
    commit('SOCKET_AUTHORIZED', false);
    clearTimeout(socketLoginTimeoutId);
    socketLoginTimeoutId = null;
    socketio.close();
  },
  SOCKET_AUTHORIZED({ commit }) {
    commit('SOCKET_AUTHORIZED', true);
  },
  socket_connect({ state, dispatch }) {
    // There is a race condition in socket.io
    // https://github.com/socketio/socket.io/issues/2273#issuecomment-172378405
    let loginTriesCount = 0;
    const authStore = useAuthStore();
    const socketLogin = () => {
      socketLoginTimeoutId = setTimeout(() => {
        if (state.authorized) {
          return;
        }
        if (loginTriesCount >= 3) {
          console.warn('bad ws connection: reconnection attempt');
          dispatch('DISCONNECT');
          dispatch('CONNECT');
          return;
        }
        loginTriesCount++;
        const token = authStore.getScopedToken;
        if (token) {
          socketio.emit('login', { all_tenants: !isSelfService() });
        }
        socketLogin();
      }, 1000);
    };

    socketLogin();
  },
  async socket_json({ dispatch }, payload) {
    if (payload.code === 200) {
      dispatch('SOCKET_AUTHORIZED');
    } else if (payload.code === 401) {
      dispatch('DISCONNECT');
      const authStore = useAuthStore();
      await authStore.signOut();
    } else if (payload.code >= 500) {
      dispatch('DISCONNECT');
      setTimeout(() => {
        dispatch('CONNECT');
      }, 5000);
    }
  },
};

export default actions;
